<i18n>
{
  "de": {
    "signInWithGoogle": "Über Google anmelden"
  },
  "en": {
    "signInWithGoogle": "Sign in with Google"
  }
}
</i18n>

<template>
  <button
    type="button"
    class="google-login-button"
    :disabled="!ready"
    @click.prevent="signIn"
  >
    <svg
      class="google-logo"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
      />
    </svg>
    <span>{{ $t('signInWithGoogle') }}</span>
  </button>
</template>

<script>
let gsiScriptPromise = null

const loadGsiScript = () => {
  if (!gsiScriptPromise) {
    gsiScriptPromise = new Promise((resolve, reject) => {
      if (window.google && window.google.accounts) {
        resolve()
        return
      }
      const script = document.createElement('script')
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      script.defer = true
      script.onload = resolve
      script.onerror = () => {
        gsiScriptPromise = null
        reject(new Error('Failed to load Google Identity Services'))
      }
      document.head.appendChild(script)
    })
  }
  return gsiScriptPromise
}

export default {
  name: 'googleLoginButton',
  props: {
    clientId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    ready: false
  }),
  async mounted() {
    try {
      await loadGsiScript()
      // non-reactive on purpose — the token client is an opaque GIS object
      this.tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: this.clientId,
        scope: 'openid email profile',
        callback: (response) => {
          if (response.error) {
            this.$emit('failure', response)
            return
          }
          this.$emit('success', response)
        },
        error_callback: (error) => {
          this.$emit('failure', error)
        }
      })
      this.ready = true
    } catch (error) {
      this.$emit('failure', error)
    }
  },
  methods: {
    signIn() {
      if (this.tokenClient) {
        this.tokenClient.requestAccessToken()
      }
    }
  }
}
</script>

<style lang="scss">
.google-login-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #3c4043;
  cursor: pointer;
  transition: background-color 150ms ease-in-out, border-color 150ms ease-in-out;

  &:hover {
    background: #f8faff;
    border-color: #d2e3fc;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }

  .google-logo {
    flex: 0 0 auto;
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
</style>
